import { SERVICES } from '../constants'

export default function ServiceCard({ service }: { service: typeof SERVICES[number] }) {
  return (
    <div
      className="relative rounded-3xl overflow-hidden bg-white/[0.04] backdrop-blur-2xl flex flex-col min-h-[360px] p-8"
      style={{
        border: `1px solid ${service.border}`,
        boxShadow: '0 20px 60px rgba(0,0,0,0.55), inset 0 1px 0 rgba(255,255,255,0.09)',
      }}
    >
      {/* Colored glow blob */}
      <div
        className="absolute -top-20 -left-20 w-72 h-72 rounded-full blur-[90px] pointer-events-none"
        style={{ background: service.glow }}
        aria-hidden
      />

      {/* Top edge highlight */}
      <div
        className="absolute inset-x-0 top-0 h-px pointer-events-none"
        style={{ background: 'linear-gradient(to right, transparent, rgba(255,255,255,0.25), transparent)' }}
        aria-hidden
      />

      <div className="relative z-10 flex flex-col h-full gap-5">
        {/* Label + icon */}
        <div className="flex items-center justify-between">

          <div className="w-10 h-10 rounded-lg bg-white/[0.07] border border-white/10 flex items-center justify-center text-white/60 shrink-0">
            <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>{service.icon}</span>
          </div>
        </div>

        {/* Title + subtitle */}
        <div>
          <h3 className="font-headline text-2xl font-bold text-white leading-tight">
            {service.title}
          </h3>
          <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-white/35">
            {service.subtitle}
          </p>
        </div>

        {/* Description */}
        <p className="text-white/55 text-sm leading-relaxed flex-1">
          {service.description}
        </p>

        {/* Feature tags */}
        <div className="flex flex-wrap gap-2 pt-1">
          {service.items.map((item) => (
            <span
              key={item}
              className="px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider border border-white/10 bg-white/[0.05] text-white/45"
            >
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}
